import { reactive } from 'vue';

type StateType = {
  hash: string;
  phoneNumber: string;
};

const state = reactive<StateType>({
  hash: '',
  phoneNumber: '',
});

export default state;
